import React, { useState } from "react";
import { m, AnimatePresence } from "framer-motion";
import Image from "next/image";
export default function CaseStudy({
  children,
  title,
  image,
  openState,
  readMore = true,
  external = false,
  link = "#",
  titleOverride = false,
  subTitle,
}) {
  const [open, setOpen] = useState(false);

  return (
    <div
      onClick={() => !external && setOpen(!open)}
      className={`${
        open ? "rounded-bl-2xl rounded-br-2xl" : "rounded-2xl"
      } px-4 w-full group flex flex-col z-0  border-[#707070]/10 overflow-hidden ${
        !external ? "cursor-pointer" : "cursor-default"
      }`}
    >
      <div className="flex flex-row justify-start gap-4 items-start w-full relative lg:h-[400px] h-[250px]">
        <div className="relative w-full lg:h-[400px] h-[250px] ">
          <Image
            src={image}
            alt="case study"
            className={`w-full h-full object-cover transition-all duration-300 ease ${
              open ? "rounded-t-2xl rounded-b-0" : "rounded-2xl"
            }`}
            fill
            sizes="(max-width: 479px) 479px,(max-width: 768px) 768px, (max-width: 1200px) 1200px,(max-width: 1920px) 1920px, 1000px"
          />
          <div className="w-full h-full flex flex-col gap-3 items-center justify-center absolute top-0 left-0 px-4 bg-black/40 rounded-2xl">
            <div
              dangerouslySetInnerHTML={
                !titleOverride ? { __html: "Case Story" } : { __html: title }
              }
              className="text-white lg:text-[40px] md:text-[32px] text-[22px] leading-tight font-semibold"
            ></div>
            <div
              dangerouslySetInnerHTML={
                !titleOverride ? { __html: title } : { __html: subTitle }
              }
              className="text-white font-body text-center leading-tight lg:max-w-[90%] lg:text-2xl md:text-xl text-[16px]"
            ></div>
            {readMore && (
              <div className="md:text-base text-sm mt-3 text-white underline scale-105 hover:text-lightBlue transform transition-all duration-300 ease">
                {!open ? "read more" : "read less"}
              </div>
            )}
            {external && (
              <a
                href={link}
                target="_blank"
                rel="noreferrer"
                className="md:text-base text-sm mt-3 text-white underline scale-105 hover:text-lightBlue transform transition-all duration-300 ease"
              >
                know more
              </a>
            )}
          </div>
        </div>
      </div>
      <AnimatePresence initial={false}>
        {open && (
          <m.div
            className="bg-white w-full"
            key="content"
            initial="collapsed"
            animate="open"
            exit="collapsed"
            variants={{
              open: { height: "auto", opacity: 1 },
              collapsed: { height: "0px", opacity: 1 },
            }}
            transition={{ duration: 0.6, ease: [0.04, 0.62, 0.23, 0.98] }}
          >
            <m.div
              variants={{ collapsed: { opacity: 0.8 }, open: { opacity: 1 } }}
              transition={{ duration: 0.3 }}
              className="w-full"
            >
              <m.div
                variants={{
                  collapsed: { y: 20, opacity: 0 },
                  open: { y: 0, opacity: 1 },
                }}
                transition={{ duration: 0.5 }}
                className="caseStudy py-8 px-6 text-sm [&>h6]:text-darkBlue md:text-base text-[#5C5C5C] flex flex-col gap-4 text-justify"
              >
                {children}
              </m.div>
            </m.div>
          </m.div>
        )}
      </AnimatePresence>
    </div>
  );
}
